import { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useTranslation } from 'react-i18next';

type IBasicExpand = {
	onExpand?: () => void;
	expanded?: boolean;
	title: string;
	className?: string;
};
const BasicExpand: FC<IBasicExpand> = ({ onExpand, expanded, title, className }) => {
	const { t } = useTranslation();
	return (
		<Box className={`mt-6 flex h-16 cursor-pointer items-center justify-between bg-primary-main px-6 ${expanded ? 'rounded-t-lg' : 'rounded-lg'} ${className}`} onClick={onExpand}>
			<Typography className="text-lg text-background-paper">{title}</Typography>
			{onExpand && (
				<Button className="px-0 text-base font-normal text-background-paper" variant="text">
					{t('see-more')}
					{expanded ? <KeyboardArrowUpIcon className="text-3xl" /> : <KeyboardArrowDownIcon className="text-3xl" />}
				</Button>
			)}
		</Box>
	);
};

export default BasicExpand;
